import {  Tabs, Badge } from 'antd'
import React, { useState } from 'react'
import LoanListAdd from './LoanListAdd'             
import Main from '../../cpn/Main';
import { PlusOutlined, ClockCircleOutlined, ScheduleOutlined, AuditOutlined, FileDoneOutlined, FileSearchOutlined } from '@ant-design/icons';
import LoanListPendding from './LoanListPendding';
import LoanListSubmitted from './LoanListSubmitted';            
import LoanListNeedApprove from './LoanListNeedApprove';
import LoanListApproved from './LoanListApproved';
import LoanListNeedRead from './LoanListNeedRead';
import LoanListAll from './LoanListAll';
function LoanList(props) {
    const qy_id = props.qy_id;
    const qy_name = props.qy_name;
    const yh_id = props.yh_id;
    const yh_name = props.yh_name;
    const yh_qx = props.yh_qx || '';  
    const [list,setList] = React.useState(props.loanList);
    React.useEffect(() => {
        if (props.loanList.length > 0) {
            const formattedData = props.loanList.map((item,index) => ({
                key: item.jk_id,
                jk_content: item.jk_content,
                jk_ctime: item.jk_ctime,
                jk_price: item.jk_price,
                jk_uname: item.jk_uname,
                jk_num: item.jk_num,                  
                jk_uid: item.jk_uid,   
                jk_type_name: item.jk_type_name,               
                jk_kh_name: item.jk_kh_name,               
                jk_amount: item.jk_amount,               
                jk_bzd_danhao:item.jk_bzd_danhao,
                jk_bzd_id:item.jk_bzd_id,
                jk_date:item.jk_date,
                jk_date_end:item.jk_date_end,
                jk_bzd_name:item.jk_bzd_name,
                jk_type_id:item.jk_type_id,
                jk_kh_id:item.jk_kh_id,
                jk_state:item.jk_state,
                jk_bm_id:item.jk_bm_id,
                jk_bm_name:item.jk_bm_name,
                jk_khyhzh_id:item.jk_khyhzh_id,
                jk_khyhzh_name:item.jk_khyhzh_name,
                jk_image_name:item.jk_image_name,
                jk_image_file:item.jk_image_file,
                jk_state_time:item.jk_state_time,
            }));
            const sortedData = formattedData.sort((a, b) => new Date(a.dsbzdsz_ctime) - new Date(b.dsbzdsz_ctime));
            setList(sortedData);
            
        }else{
            setList([])
        }}, [props.loanList])
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-caiwu_loan_active_key') || '1');
    return (
        <Main 
            selectedKeys={['/LoanList']}
            qy_id={props.qy_id}
            qy_name={props.qy_name}
            yh_id={props.yh_id}
            yh_name={props.yh_name}
            loanNeedApproveNum={props.loanNeedApproveNum}
            loanNeedReadNum={props.loanNeedReadNum}
            loanRejectedNum={props.loanRejectedNum}
            loanEndNeedReadNum={props.loanEndNeedReadNum}
            reportRejectedNum={props.reportRejectedNum}
            reportNeedApproveNum={props.reportNeedApproveNum}
            reportNeedReadNum={props.reportNeedReadNum}
            reportEndNeedReadNum={props.reportEndNeedReadNum}
            expenseNeedApproveNum={props.expenseNeedApproveNum}
            expenseNeedReadNum={props.expenseNeedReadNum}
            expenseRejectedNum={props.expenseRejectedNum}
            expenseEndNeedReadNum={props.expenseEndNeedReadNum}
            ddzcNeedApproveNum={props.ddzcNeedApproveNum}
            ddzcNeedReadNum={props.ddzcNeedReadNum}
            ddzcRejectedNum={props.ddzcRejectedNum}
            ddzcEndNeedReadNum={props.ddzcEndNeedReadNum}
            ddsrNeedApproveNum={props.ddsrNeedApproveNum}
            ddsrNeedReadNum={props.ddsrNeedReadNum}
            ddsrRejectedNum={props.ddsrRejectedNum}
            ddsrEndNeedReadNum={props.ddsrEndNeedReadNum}
            invoiceNeedApproveNum={props.invoiceNeedApproveNum}
            invoiceNeedReadNum={props.invoiceNeedReadNum}
            invoiceRejectedNum={props.invoiceRejectedNum}
            invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
            yh_qx={props.yh_qx}
        >                            
            <Tabs
                activeKey={activeKey} 
                onChange={(key) => {    
                    setActiveKey(key)
                    localStorage.setItem('jtg-caiwu_loan_active_key', key)
                }}
                items={[
                    {
                        key: '0',
                        label: '新增',
                        children: <LoanListAdd qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <PlusOutlined />,
                    },
                    {
                        key: '1',
                        label: '我未提交的',
                        children: <LoanListPendding qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <ClockCircleOutlined />,
                    },
                    {
                        key: '2',
                        label: <span>我已提交的<Badge count={Number(props.loanRejectedNum) + Number(props.loanEndNeedReadNum)}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <LoanListSubmitted qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} loanRejectedNum={props.loanRejectedNum} loanEndNeedReadNum={props.loanEndNeedReadNum} yh_qx={yh_qx}/>,
                        icon: <ScheduleOutlined />,
                    },
                    {
                        key: '3',
                        label: <span>需要我审批的<Badge count={props.loanNeedApproveNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <LoanListNeedApprove qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.loanSpList} yh_qx={yh_qx}/>,
                        icon: <AuditOutlined />,
                    },
                    {
                        key: '4',
                        label: '我已审批的',
                        children: <LoanListApproved qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.loanSpList} yh_qx={yh_qx}/>,
                        icon: <FileDoneOutlined />,
                    },
                    {
                        key: '5',
                        label: <span>抄送给我的<Badge count={props.loanNeedReadNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <LoanListNeedRead qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.loanSpList} yh_qx={yh_qx}/>,
                        icon: <FileDoneOutlined />,
                    },
                    ...(yh_qx.includes('管理') ? [{
                        key: '6',
                        label: '全部单据',
                        children: <LoanListAll qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.loanList} yh_qx={yh_qx}/>,
                        icon: <FileSearchOutlined />,
                    }] : []),
                ]}
            />
        </Main>
    )
}

export default LoanList